/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import IntegrationsashWellnessAshWellnessIntegration from './IntegrationsashWellnessAshWellnessIntegration';

/**
 * The IntegrationsAshWellnessBody model module.
 * @module model/IntegrationsAshWellnessBody
 * @version v0.3
 */
export default class IntegrationsAshWellnessBody {
  /**
   * Constructs a new <code>IntegrationsAshWellnessBody</code>.
   * @alias module:model/IntegrationsAshWellnessBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>IntegrationsAshWellnessBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/IntegrationsAshWellnessBody} obj Optional instance to populate.
   * @return {module:model/IntegrationsAshWellnessBody} The populated <code>IntegrationsAshWellnessBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new IntegrationsAshWellnessBody();
      if (data.hasOwnProperty('ash_wellness_integration'))
        obj.ashWellnessIntegration = IntegrationsashWellnessAshWellnessIntegration.constructFromObject(data['ash_wellness_integration']);
    }
    return obj;
  }
}

/**
 * @member {module:model/IntegrationsashWellnessAshWellnessIntegration} ashWellnessIntegration
 */
IntegrationsAshWellnessBody.prototype.ashWellnessIntegration = undefined;

